import React from 'react';
import { Provider } from 'react-redux';
import { store } from 'store';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import Root from 'pages/Root';
import 'assets/app.scss';
import Notifications from 'features/notifications/Notifications';
import history from 'helpers/history';
import './i18n';
import { Cookie } from 'layouts';
import PwaModal from 'features/pwa/PwaModal';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Notifications />
      <Router history={history}>
        <Root />
      </Router>
      <Cookie />
      <PwaModal />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
